import { v4 as uuidv4 } from 'uuid';
import { safeStorage } from './safe-storage';

const DEVICE_ID_KEY = 'VIDU_DEVICE_ID';
const DEVICE_ID_PREFIX = 'DEVICE';

export const getDeviceId = () => {
  // 检查 localStorage 中是否已经存在设备 ID
  let deviceId = safeStorage.getItem(DEVICE_ID_KEY);

  if (!deviceId) {
    // 如果不存在，生成一个新的设备 ID
    deviceId = `${DEVICE_ID_PREFIX}_${uuidv4()}`;
    // 将设备 ID 存储到 localStorage
    safeStorage.setItem(DEVICE_ID_KEY, deviceId);
  }

  return deviceId;
};
